import React from 'react';
import { Div } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
//43
import {
    ItemsNotAllowedText,
    ExclusionItemsNotAllowedDiv,
    ItemsSubText,
} from './Notifications.styled';
import { useTranslation } from 'react-i18next';
const AddedMoreThanTenItems = ({
    onClose,
    title,
    allowedCount,
    showProductTemplateMessage = false,
    onCancel = () => {},
    opacity = 10,
}) => {
    const {t} = useTranslation();
    return (
        <>
            <Popup
                title={
                    title
                        ? title
                        : t('scheduleSurgery.surgery.notifications.AddedMoreThanTenItems.popMsg')
                }
                onClose={onClose}
                width={showProductTemplateMessage ? '' : '300px'}
                webWidth={showProductTemplateMessage ? '' : '352px'}
                webHeight={showProductTemplateMessage ? '' : '78px'}
                fontSize={'17px'}
                opacity={opacity}
                id={'surgery-notes-addedMoreThanTenItems-popup'}
            >
                {showProductTemplateMessage ? (
                    <ExclusionItemsNotAllowedDiv
                        mbHeight={'150px'}
                        height={'132px'}
                        width={'100%'}
                        hideScroll={true}
                    >
                        {showProductTemplateMessage ? (
                            <>
                                <ItemsNotAllowedText margin={'0px'}>
                                    {`${allowedCount} 
                                ${t('consignmentReturn.surgery.notifications.setsAdded')} `}
                                </ItemsNotAllowedText>
                                <ItemsSubText
                                    height={'40px'}
                                    webHeight={'unset'}
                                >
                                    {t('consignmentReturn.surgery.notifications.moreNumberItems')}
                                </ItemsSubText>
                            </>
                        ) : null}
                    </ExclusionItemsNotAllowedDiv>
                ) : null}

                {showProductTemplateMessage ? (
                    <Div showCancel={true} justifyContent={'flex-end'}>
                        <Button
                         id={'surgery-notifications-addedmorethentenitems-cancel'}
                          variant={ButtonStyles?.popUpSecondary}
                           // popUpSecondary={true}
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            margin={'13px 3px 0px 0px'}
                            fontSize={'13px'}
                            clicked={onCancel}
                        >
                            {t('consignmentReturn.surgery.notifications.cancel')}
                        </Button>
                        <Button
                            id={'surgery-notifications-addedmorethentenitems-okbutton'}
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            variant={ButtonStyles?.primary}
                            // primary={true}
                            margin={'13px 5px 0px 2px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                            {t('consignmentReturn.surgery.notifications.ok')}
                        </Button>
                    </Div>
                ) : (
                    <Div>
                            <Button
                                id={'surgery-notifications-addedmorethentenitems-ok'}
                                show={true}
                                width={'150px'}
                                height={'38px'}
                                // primary={true}
                                variant={ButtonStyles?.primary}
                                margin={'5px 0px 5px 5px'}
                                fontSize={'13px'}
                                clicked={onClose}
                            >
                            {t('consignmentReturn.surgery.notifications.ok')}
                        </Button>
                    </Div>
                )}
            </Popup>
        </>
    );
};

export default AddedMoreThanTenItems;
